//var $ = require("zepto");
var $ = require("jquery");
var Util = {};

String.prototype.params = function (sep) {
    sep = sep || "&";
    var paramMap = {};
    if (this.length > 0) {
        if (this.split("?").length > 1) {
            var paramArray = this.split("?")[1].split(sep);
        } else {
            var paramArray = this.split(sep);
        }
        for (var i = 0; i < paramArray.length; ++i) {
            var paramPair = paramArray[i].split("=");
            paramPair[0] = unescape(paramPair[0]);
            paramPair[1] = paramPair[1] ? unescape(paramPair[1]) : "";
            if (!paramMap[paramPair[0]]) {
                paramMap[paramPair[0]] = paramPair[1].replace(/\'|\"/g, "");
            }
        }
    }
    return paramMap;
};
$.extend(String.prototype, {
    replaceAll: function (sFrom, sTo) {
        return this.split(sFrom).join(sTo);
    },
    replacePairs: function () {
        var s = this;
        for (var i = 0; i < arguments.length; ++i) {
            s = s.replaceAll(arguments[i][0], arguments[i][1]);
        }
        return s;
    },
    toDJHtml: function () {
        var CONVERT_ARRAY = [
            ["&#38;", "&"],
            ["&#32;", " "],
            ["&#39;", "'"],
            ["&#34;", '"'],
            ["&#47;", "/"],
            ["&#60;", "<"],
            ["&#62;", ">"],
            ["&#92;", "\\"],
            ["&lt;", "<"],
            ["&nbsp;", " "],
            ["&amp;nbsp;", " "],
            ["&gt;", ">"],
            ["&quot;", '"'],
            ["<br />", "\n"],
        ];
        return this.replacePairs.apply(this, CONVERT_ARRAY);
    },
});
$.extend(Util, {
    request:function(key){
        var params = location.href.params();
        return params[key];
    },
    param: function (a, isescape) {
        isescape = isescape ? true : false;
        var s = [];
        function add(key, value) {
            if (isescape) {
                s[s.length] = escape(key) + "=" + escape(value);
            } else {
                s[s.length] = key + "=" + value;
            }
        }
        if ($.isArray(a) || a.jquery)
            $.each(a, function () {
                add(this.name, this.value);
            });
        else
            for (var j in a)
                if ($.isArray(a[j]))
                    $.each(a[j], function () {
                        add(j, this);
                    });
                else add(j, $.isFunction(a[j]) ? a[j]() : a[j]);
        return s.join("&").replace(/%20/g, "+");
    },
    loadCSS: function (url, callback) {
        var file_name = url.substr(url.lastIndexOf("/") + 1);
        var link_name = file_name.split(".")[0];
        if ($("#load_" + link_name).size() <= 0) {
            var head = document.getElementsByTagName("HEAD").item(0);
            var style = document.createElement("link");
            style.href = url;
            style.rel = "stylesheet";
            style.type = "text/css";
            style.id = "load_" + link_name;
            head.appendChild(style);
        }
        $.isFunction(callback) && callback();
    },
    isWeixin: function () {
        var ua = navigator.userAgent.toLowerCase();
        return ua.match(/MicroMessenger/i) == "micromessenger";
    },
    getServerDateTime: function () {
        var date = new Date($.ajax({ async: false, data: { r: Math.random() } }).getResponseHeader("Date"));
        var datestring = Util.date("Y-m-d H:i:s", date.getTime() / 1e3);
        window.JSON_sys_time = { iRet: "0", sMsg: datestring };
        return datestring;
    },
    getServerTime: function () {
        var date = new Date($.ajax({ async: false, data: { r: Math.random() } }).getResponseHeader("Date"));
        var datestring = Util.date("Y-m-d H:i:s", date.getTime() / 1e3);
        window.JSON_sys_time = { iRet: "0", sMsg: datestring };
        return date.getTime() / 1e3;
    },
    getScript: function (src, func, charset) {
        var script = document.createElement("script");
        script.async = "async";
        script.src = src;
        script.charset = charset || "gbk";
        if (func) {
            script.onload = func;
        }
        document.getElementsByTagName("head")[0].appendChild(script);
    },
    floadjs: function (url, sucfn, failfn) {
        var FBrowser = {};
        var h = document.getElementsByTagName("HEAD").item(0);
        var js = document.createElement("script");
        FBrowser.isIE = navigator.userAgent.indexOf("MSIE") == -1 ? false : true;
        FBrowser.isFirefox = navigator.userAgent.indexOf("Firefox") == -1 ? false : true;
        FBrowser.isOpera = navigator.userAgent.indexOf("Opera") == -1 ? false : true;
        js.type = "text/javascript";
        js.onerror = function () {
            if (typeof failfn == "function") failfn();
        };
        if (FBrowser.isIE) {
            js.onreadystatechange = function () {
                if (this.readyState.toLowerCase() != "complete" && this.readyState.toLowerCase() != "loaded") return;
                if (this.$funExeced != true && typeof sucfn == "function") {
                    this.$funExeced = true;
                    h.removeChild(js);
                    sucfn();
                }
            };
        } else {
            js.onload = function () {
                if (typeof sucfn == "function") {
                    sucfn();
                    h.removeChild(js);
                }
            };
        }
        js.src = url;
        h.appendChild(js);
        if (FBrowser.isOpera && typeof sucfn == "function") {
            sucfn();
            h.removeChild(js);
        }
    },
    toUTime: function (time) {
        if (!time) return false;
        var beginTimes = time.substring(0, 10).split("-");
        var b_daytime;
        if (time.substring(11).indexOf(":") > 0) {
            b_daytime = time.substring(11).split(":");
        } else {
            b_daytime = [0, 0, 0, 0];
        }
        var b_time = parseInt(b_daytime[0], 10) * 36e5 + parseInt(b_daytime[1] || 0, 10) * 6e4 + parseInt(b_daytime[2] || 0, 10) * 1e3;
        var beginTime = new Date(beginTimes[1] + "/" + beginTimes[2] + "/" + beginTimes[0]).getTime() + b_time;
        return Math.ceil(beginTime / 1e3);
    },
    time: function () {
        return Math.floor(new Date().getTime() / 1e3);
    },
    cookie: function (name, value, options) {
        if (typeof value != "undefined") {
            options = options || {};
            var expires = "";
            var date = new Date();
            if (value === null) {
                value = "";
                date.setTime(date.getTime() - 1);
                expires = "; expires=" + date.toUTCString();
            } else if (options.expires && (typeof options.expires == "number" || options.expires.toUTCString)) {
                if (typeof options.expires == "number") {
                    date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1e3);
                } else {
                    date = options.expires;
                }
                expires = "; expires=" + date.toUTCString();
            }
            var path = options.path ? "; path=" + options.path : "; path=/";
            var domain = options.domain ? "; domain=" + options.domain : "";
            var secure = options.secure ? "; secure" : "";
            document.cookie = [name, "=", encodeURIComponent(value), expires, path, domain, secure].join("");
        } else {
            var cookieValue = null;
            if (document.cookie && document.cookie != "") {
                var cookies = document.cookie.split(";");
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = $.trim(cookies[i]);
                    if (cookie.substring(0, name.length + 1) == name + "=") {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
    },
    showTimeLeft: function (nowDate, endDate) {
        var nowTime = Util.toUTime(nowDate);
        var endTime = Util.toUTime(endDate);
        var leftTime = endTime - nowTime;
        if (leftTime < 0) {
            return false;
        }
        var leftsecond = parseInt(leftTime);
        var day1 = Math.floor(leftsecond / (60 * 60 * 24));
        var hour = Math.floor((leftsecond - day1 * 24 * 60 * 60) / 3600);
        var minute = Math.floor((leftsecond - day1 * 24 * 60 * 60 - hour * 3600) / 60);
        var second = Math.floor(leftsecond - day1 * 24 * 60 * 60 - hour * 3600 - minute * 60);
        return [second, minute, hour, day1];
    },
    date: function (format, timestamp) {
        var that = this,
            jsdate,
            f,
            formatChr = /\\?([a-z])/gi,
            formatChrCb,
            _pad = function (n, c) {
                if ((n = n + "").length < c) {
                    return new Array(++c - n.length).join("0") + n;
                }
                return n;
            },
            txt_words = ["Sun", "Mon", "Tues", "Wednes", "Thurs", "Fri", "Satur", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        formatChrCb = function (t, s) {
            return f[t] ? f[t]() : s;
        };
        f = {
            d: function () {
                return _pad(f.j(), 2);
            },
            D: function () {
                return f.l().slice(0, 3);
            },
            j: function () {
                return jsdate.getDate();
            },
            l: function () {
                return txt_words[f.w()] + "day";
            },
            N: function () {
                return f.w() || 7;
            },
            S: function () {
                var j = f.j();
                return j > 4 && j < 21 ? "th" : { 1: "st", 2: "nd", 3: "rd" }[j % 10] || "th";
            },
            w: function () {
                return jsdate.getDay();
            },
            z: function () {
                var a = new Date(f.Y(), f.n() - 1, f.j()),
                    b = new Date(f.Y(), 0, 1);
                return Math.round((a - b) / 864e5) + 1;
            },
            W: function () {
                var a = new Date(f.Y(), f.n() - 1, f.j() - f.N() + 3),
                    b = new Date(a.getFullYear(), 0, 4);
                return _pad(1 + Math.round((a - b) / 864e5 / 7), 2);
            },
            F: function () {
                return txt_words[6 + f.n()];
            },
            m: function () {
                return _pad(f.n(), 2);
            },
            M: function () {
                return f.F().slice(0, 3);
            },
            n: function () {
                return jsdate.getMonth() + 1;
            },
            t: function () {
                return new Date(f.Y(), f.n(), 0).getDate();
            },
            L: function () {
                return (new Date(f.Y(), 1, 29).getMonth() === 1) | 0;
            },
            o: function () {
                var n = f.n(),
                    W = f.W(),
                    Y = f.Y();
                return Y + (n === 12 && W < 9 ? -1 : n === 1 && W > 9);
            },
            Y: function () {
                return jsdate.getFullYear();
            },
            y: function () {
                return (f.Y() + "").slice(-2);
            },
            a: function () {
                return jsdate.getHours() > 11 ? "pm" : "am";
            },
            A: function () {
                return f.a().toUpperCase();
            },
            B: function () {
                var H = jsdate.getUTCHours() * 3600,
                    i = jsdate.getUTCMinutes() * 60,
                    s = jsdate.getUTCSeconds();
                return _pad(Math.floor((H + i + s + 3600) / 86.4) % 1e3, 3);
            },
            g: function () {
                return f.G() % 12 || 12;
            },
            G: function () {
                return jsdate.getHours();
            },
            h: function () {
                return _pad(f.g(), 2);
            },
            H: function () {
                return _pad(f.G(), 2);
            },
            i: function () {
                return _pad(jsdate.getMinutes(), 2);
            },
            s: function () {
                return _pad(jsdate.getSeconds(), 2);
            },
            u: function () {
                return _pad(jsdate.getMilliseconds() * 1e3, 6);
            },
            e: function () {
                throw "Not supported (see source code of date() for timezone on how to add support)";
            },
            I: function () {
                var a = new Date(f.Y(), 0),
                    c = Date.UTC(f.Y(), 0),
                    b = new Date(f.Y(), 6),
                    d = Date.UTC(f.Y(), 6);
                return 0 + (a - c !== b - d);
            },
            O: function () {
                var tzo = jsdate.getTimezoneOffset(),
                    a = Math.abs(tzo);
                return (tzo > 0 ? "-" : "+") + _pad(Math.floor(a / 60) * 100 + (a % 60), 4);
            },
            P: function () {
                var O = f.O();
                return O.substr(0, 3) + ":" + O.substr(3, 2);
            },
            T: function () {
                return "UTC";
            },
            Z: function () {
                return -jsdate.getTimezoneOffset() * 60;
            },
            c: function () {
                return "Y-m-d\\Th:i:sP".replace(formatChr, formatChrCb);
            },
            r: function () {
                return "D, d M Y H:i:s O".replace(formatChr, formatChrCb);
            },
            U: function () {
                return (jsdate.getTime() / 1e3) | 0;
            },
        };
        this.date = function (format, timestamp) {
            that = this;
            timestamp = parseInt(timestamp);
            if (timestamp) {
                timestamp = parseInt(timestamp);
                timestamp += (480 + new Date().getTimezoneOffset()) * 60;
            }
            jsdate = typeof timestamp === "undefined" ? new Date() : timestamp instanceof Date ? new Date(timestamp) : new Date(timestamp * 1e3);
            return format.replace(formatChr, formatChrCb);
        };
        return this.date(format, timestamp);
    },
    transQbPrice: function (price) {
        var s_num = (price / 100).toFixed(10) + "";
        return s_num.substring(0, s_num.indexOf(".") < 0 ? s_num.length : s_num.indexOf(".") + 3);
    },
    getACSRFToken: function (str) {
        if (str) {
            var hash = 5381;
            for (var i = 0, len = str.length; i < len; ++i) {
                hash += (hash << 5) + str.charAt(i).charCodeAt();
            }
            return hash & 2147483647;
        }
    },
    getACSRFTokenForWx: function (str) {
        if (str && str.length > 32) {
            str = str.substr(22, 10);
            var hash = 5381;
            for (var i = 0, len = str.length; i < len; ++i) {
                hash += (hash << 5) + str.charAt(i).charCodeAt();
            }
            return hash & 2147483647;
        }
    },
    myTypeof: function (o) {
        var _toString = Object.prototype.toString;
        var _type = { undefined: "undefined", number: "number", boolean: "boolean", string: "string", "[object Function]": "function", "[object RegExp]": "regexp", "[object Array]": "array", "[object Date]": "date", "[object Error]": "error" };
        return _type[typeof o] || _type[_toString.call(o)] || (o ? "object" : "null");
    },
    channelExclude: function () {
        var all_arguments = arguments;
        var valid_arguments = ["ios", "IOS", "android", "ANDROID", "weixin", "WEIXIN", "qq", "QQ"];
        if (arguments.length <= 0) {
            alert("\u8bf7\u8f93\u5165\u8fc7\u6ee4\u7684\u6e20\u9053");
            return;
        }
        for (var i = 0; i < arguments.length; i++) {
            if (valid_arguments.indexOf(arguments[i]) < 0) {
                alert("\u62b1\u6b49\uff0c\u60a8\u8f93\u5165\u7684\u8fc7\u6ee4\u6e20\u9053\u4e0d\u6b63\u786e\uff0c\u60a8\u53ef\u4ee5\u8f93\u5165'ios'\u3001'android'\u3001'weixin'\u3001'qq'");
                return;
            }
        }
        setInterval(function () {
            if (typeof ams_actdesc != "undefined") {
                var biz = ams_actdesc["sServiceType"];
                if ($("#roleselecter" + biz).is(":visible")) {
                    ios_re = new RegExp(/ios|\u82f9\u679c/i);
                    android_re = new RegExp(/android|\u5b89\u5353/i);
                    weixin_re = new RegExp(/weixin|\u5fae\u4fe1/i);
                    qq_re = new RegExp(/qq|\u624bQ/);
                    $("#channelContentId_" + biz)
                        .find("option")
                        .each(function () {
                            $this = $(this);
                            for (var i = 0; i < all_arguments.length; i++) {
                                var reg_name = all_arguments[i].toLowerCase() + "_re";
                                var reg = eval(reg_name);
                                if (reg.test($this.text())) {
                                    $this.remove();
                                }
                            }
                        });
                }
            }
        }, 100);
    },
    channelInclude: function (channel) {
        channel = channel.replace(/\s+/g, "").toLowerCase();
        valid_args_re = new RegExp(/(all|ios|android|\u82f9\u679c|\u5b89\u5353|weixin|qq|\u5fae\u4fe1|\u624bq)/i);
        if (!valid_args_re.test(channel)) {
            alert("\u8bf7\u5728\u6a21\u5757\u914d\u7f6e\u7684'\u6807\u7b7e'\u4e2d\u8f93\u5165\u6d3b\u52a8\u5f00\u653e\u7684\u6e20\u9053,\u8f93\u5165'android'\u6216\u8005'\u5b89\u5353'\u8868\u793a\u53ea\u5f00\u653e\u5b89\u5353\u6e20\u9053\uff08\u5305\u62ec\u5fae\u4fe1\u548c\u624bQ\uff09\uff0c\u8f93\u5165'android qq'\u6216\u8005'\u5b89\u5353\u624bQ'\u8868\u793a\u53ea\u5f00\u653e\u5b89\u5353\u624bQ\u6e20\u9053");
            return;
        }
        var re_array = [new RegExp(/ios|\u82f9\u679c/i), new RegExp(/android|\u5b89\u5353/i), new RegExp(/weixin|\u5fae\u4fe1/i), new RegExp(/qq|\u624bQ/i)];
        var system_re_array = [new RegExp(/ios|\u82f9\u679c/i), new RegExp(/android|\u5b89\u5353/i)];
        var channal_re_array = [new RegExp(/weixin|\u5fae\u4fe1/i), new RegExp(/qq|\u624bQ/i)];
        if ((system_re_array[0].test(channel) && system_re_array[1].test(channel)) || (channal_re_array[0].test(channel) && channal_re_array[1].test(channel))) {
            alert("\u60a8\u586b\u5199\u7684\u5f00\u653e\u6e20\u9053\u6807\u7b7e\u683c\u5f0f\u6709\u8bef\uff0c\u82e5ios\u548candroid\u90fd\u5f00\u653e\uff0c\u60a8\u65e0\u9700\u586b\u5199\uff1b\u540c\u7406\uff0c\u82e5\u624bQ\u548c\u5fae\u4fe1\u540c\u65f6\u5f00\u653e\uff0c\u60a8\u4e5f\u65e0\u9700\u586b\u5199\u624bQ\u5fae\u4fe1");
            return;
        }
        setInterval(function () {
            if (typeof ams_actdesc != "undefined") {
                var biz = ams_actdesc["sServiceType"];
                if ($("#roleselecter" + biz).is(":visible")) {
                    if ($("#systemContentId_" + biz).size() == 0) {
                        var check_array = new Array();
                        for (var i = 0; i < re_array.length; i++) {
                            if (re_array[i].test(channel)) {
                                check_array.push(re_array[i]);
                            }
                        }
                        $("#channelContentId_" + biz)
                            .find("option")
                            .each(function () {
                                $this = $(this);
                                for (var i = 0; i < check_array.length; i++) {
                                    if (!check_array[i].test($this.text()) && $this.text() != "\u8bf7\u9009\u62e9\u6e20\u9053") {
                                        $this.remove();
                                    }
                                }
                            });
                    } else {
                        var sys_check_array = new Array();
                        var channel_check_array = new Array();
                        for (var i = 0; i < system_re_array.length; i++) {
                            if (system_re_array[i].test(channel)) {
                                sys_check_array.push(system_re_array[i]);
                            }
                        }
                        for (var i = 0; i < channal_re_array.length; i++) {
                            if (channal_re_array[i].test(channel)) {
                                channel_check_array.push(channal_re_array[i]);
                            }
                        }
                        $("#channelContentId_" + biz)
                            .find("option")
                            .each(function () {
                                $this = $(this);
                                for (var i = 0; i < channel_check_array.length; i++) {
                                    if (!channel_check_array[i].test($this.text()) && $this.text() != "\u8bf7\u9009\u62e9\u6e20\u9053") {
                                        $this.remove();
                                    }
                                }
                            });
                        $("#systemContentId_" + biz)
                            .find("option")
                            .each(function () {
                                $this = $(this);
                                for (var i = 0; i < sys_check_array.length; i++) {
                                    if (!sys_check_array[i].test($this.text()) && $this.text() != "\u8bf7\u9009\u62e9\u7cfb\u7edf") {
                                        $this.remove();
                                    }
                                }
                            });
                    }
                }
            }
        }, 100);
    },
});

export default Util;
